// Generated by scripts/generate-icons.ts from @phosphor-icons/react; change the table there.
import { icon } from "#components/icons/icon";

export const CircleNotchIcon = icon(
  "M236,128a108,108,0,0,1-216,0c0-42.52,24.73-81.34,63-98.9A12,12,0,1,1,93,50.91C63.24,64.57,44,94.83,44,128a84,84,0,0,0,168,0c0-33.17-19.24-63.43-49-77.09A12,12,0,1,1,173,29.1C211.27,46.66,236,85.48,236,128Z",
);
